import { ref } from 'vue';

const isFullscreen = ref(false);

export function useFullScreen() {
  console.log('iniciando el fullscreen');
  isFullscreen.value = !!document.fullscreenElement;

  document.addEventListener('fullscreenchange', () => {
    if (document.fullscreenElement) {
      isFullscreen.value = true;
      console.log('cambio el fullscreen', isFullscreen.value);
      return;
    }
    isFullscreen.value = false;
    console.log('cambio el fullscreen', isFullscreen.value);
  });

  const enterFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
      }
    } catch (err) {
      console.error('Error al entrar en modo pantalla completa:', err);
    }
  };

  const exitFullscreen = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      }
    } catch (err) {
      console.error('Error al salir del modo pantalla completa:', err);
    }
  };

  const toggleFullscreen = async () => {
    if (document.fullscreenElement) {
      await exitFullscreen();
    } else {
      await enterFullscreen();
    }
  };

  return {
    isFullscreen,
    enterFullscreen,
    exitFullscreen,
    toggleFullscreen,
  };
}
